export default __webpack_public_path__ + "static/media/ICC_Logo_Vector_Arrows-01.61f972b4.svg";